import {
    Avatar,
    Box,
    Button,
    Checkbox,
    Dialog,
    FormControlLabel,
    FormGroup,
    Grid,
    Hidden,
    Skeleton,
    Theme,
    Typography,
} from "@mui/material";
import {
    Fragment,
    useEffect,
    useState
} from "react";
import {
    checkImageExists,
    formatDateToIST,
    getAbbreviatedName,
    isNewAdditionalPurchase,
    isOnboardingTypeMinor,
    maskInfo,
    toINR
} from "../../utils/utilityFunctions";
import CartItemInfo from "./CartItemInfo";
import {
    CartItemDetails,
    Categories,
    ColorMap,
    CurrentEditObj,
    DiyFundsCartData,
    EditCartFormData,
    RecommendedFundsCartData,
    UserDetails
} from "./types";
import { LoadingButton } from "@mui/lab";
import { CheckIcon, SuccessIcon, UnCheckIcon } from "../../assets/SvgIcons";
import EditCartItem from "./EditCartItem";
import {
    useDispatch,
    useSelector
} from "react-redux";
import { RootStateType } from "../../redux-store/reducers";
import { applicantStatusMasters, BSE_PAYMENT_FLOW, COMMON_EDIT, HELDAWAY_PORTFOLIO_STATUS, USER_ROLES } from "../../utils/constant";
import {
    DeleteCartItemResponseBody,
    EditCartItemResponseBody,
    GetCartItemsCountResponseBody,
    GetCartItemsResponseBody,
    PlaceOrderResponseBody
} from "../../redux-store/types/cart";
import {
    deleteCartItem,
    editCartItem,
    getCartItems,
    getCartItemsCount,
    placeOrder,
    setCartItemsCount
} from "../../redux-store/actions/cart";
import LoadingComponent from "./LoadingComponent";
import { euinCheck, getInvestmentUserDetails, getRiskProfileCheck, getTransactionStatus, getTransactionStatusCheck } from "../../redux-store/actions/funds";
import { EnuinStatusObj, GetInvestmentUserDetails, GetNotificationsResponseBody, getTransactionStatusCheckRes, TransactionStatusObj } from "../../redux-store/types/api-types";
import { useHistory } from "react-router";
import {
    setAppliedFundsFilters,
    setSelectedSchemesObj
} from "../../redux-store/actions/investorProfile";
import { showError } from "../../redux-store/actions/auth";
import RiskProfilePopup from "../investorOverview/common/RiskProfilePopup";
import TransactionStatusPopup from "../investorOverview/common/TransactionStatusPopup";
import dayjs from "dayjs";
import EUINPopup from "../investorOverview/common/EUINPopup";
import TransactionStatusCheckPopup from "../investorOverview/common/TransactionStatusCheckPopup";
import { getNotifications } from "../../redux-store/actions/notifications";
import { storeNotifications } from "../../redux-store/actions/navbarInfo";
import { TransactionsDisclaimer, TransactionsDisclaimerText } from "../ApplicationDetails/TermsAndConditions";
import { cancelPlaceOrderOnSkip, registerPlaceOrderOnSkip } from "../../redux-store/nomineeRetryRegistry";

const categoryMap: Record<string, string> = {
    additionalPurchase: "Additional Purchase",
    newPurchase: "New Purchase",
    redemption: "Redemption",
    stp: "STP",
    switch: "Switch",
    swp: "SWP"
}

const initialCategories = [
    { label: "New Purchase", count: 0 },
    { label: "Additional Purchase", count: 0 },
    { label: "SWP", count: 0 },
    { label: "STP", count: 0 },
    { label: "Switch", count: 0 },
    { label: "Redemption", count: 0 }
]

const colorMap: ColorMap = {
    "low risk": "success.500",
    "very high risk": "error.500",
    "": "text.primary"
}


export default function Cart(): JSX.Element {
    const dispatch = useDispatch()

    const history = useHistory();

    const [categoriesArray, setCategoriesArray] = useState<Categories[]>(initialCategories)
    const [activeCategory, setActiveCategory] = useState<string>("New Purchase")

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [recommendedFundsData, setRecommendedFundsData] = useState<RecommendedFundsCartData[]>([])
    const [diyFundsData, setDiyFundsData] = useState<DiyFundsCartData[]>([])

    const [userDetails, setUserDetails] = useState<UserDetails>({
        userName: "",
        userStatus: "",
        userMobile: "",
        userEmail: "",
        userAccountType: "",
        userApplicationType: "",
        userModeOfHolding: ""
    })

    const [isConfirmationDialogVisible, setConfirmationDialogVisible] = useState<boolean>(false)
    const [isEditDialogVisible, setEditDialogVisible] = useState<boolean>(false)
    const [currentEditObj, setCurrentEditObj] = useState<CurrentEditObj>({} as CurrentEditObj)
    const [isEditCartLoading, setEditCartLoading] = useState<boolean>(false)

    const [isValidationDialogVisible, setValidationDialogVisible] = useState<boolean>(false)
    const [validationErrorsArray, setValidationErrorsArray] = useState<{ schemeName: string; errorMessage: string }[]>([])

    const [isOtpErrorDialogVisible, setOtpErrorDialogVisible] = useState<boolean>(false)
    const [otpErrorMessage, setOtpErrorMessage] = useState<string>("")

    const [isOrderPlaced, setOrderPlacedStatus] = useState<boolean>(false)
    const [isOrderPlacedLoading, setOrderPlacedLoading] = useState<boolean>(false)

    const { role = "" } = useSelector((store: RootStateType) => store.auth);

    const { investorClientId = "", iwappRmId = "", clientInterfaceCode } = useSelector((store: RootStateType) => store.id);
    const { selectedPortfolio, isPortfolioHeldaway, selectedPortfolioObj } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    const [riskProfilePopup, setRiskProfilePopup] = useState<boolean>(false);
    const [riskPopupText, setRiskPopupText] = useState<string>('');
    const [riskPflChkLoading, setRiskPflChkLoading] = useState<boolean>(false);

    const schemeIds = [...recommendedFundsData.map((item: RecommendedFundsCartData) => item.fromSchemeId), ...diyFundsData.map((item: DiyFundsCartData) => item.fromSchemeId)];

    const [transactionStatusPopup, setTransactionStatusPopup] = useState<boolean>(false);
    const [transactionStatusCheckPopup, setTransactionStatusCheckPopup] = useState<boolean>(false);
    const [TransactionStatusChkLoading, setTransactionStatusChkLoading] = useState<boolean>(false);
    const [transactionStatusPopupRes, setTransactionStatusPopupRes] = useState<TransactionStatusObj>({} as TransactionStatusObj);
    const [EUINPopupVisible, setEUINPopupVisible] = useState<boolean>(false);
    const [EUINPopupRes, setEUINPopupRes] = useState<EnuinStatusObj>({} as EnuinStatusObj);
    const [EUINPopupLoading, setEUINPopupLoading] = useState<boolean>(false);
    const [disclaimerChecked, setDisclaimerChecked] = useState<boolean>(false);
    const [isTxnDialog, setIsTxnDialog] = useState<boolean>(false);

    const [transactionStatusCheckPopupRes, setTransactionStatusCheckPopupRes] = useState<getTransactionStatusCheckRes>({} as getTransactionStatusCheckRes);

    const fetchUserDetails = async () => {
        if (role === USER_ROLES.INVESTOR && investorClientId) {
            const userDetailsResponse = await (dispatch(getInvestmentUserDetails(
                { clientCode: investorClientId, portfolioId: selectedPortfolio?.value }
            )) as unknown as Promise<GetInvestmentUserDetails>)

            if (Object.keys(userDetailsResponse).length) {
                setUserDetails({
                    userName: userDetailsResponse?.name ?? "",
                    userStatus: userDetailsResponse?.status ?? "",
                    userMobile: userDetailsResponse?.mobile ?? "",
                    userEmail: userDetailsResponse?.email ?? "",
                    userAccountType: userDetailsResponse?.accountType ?? "",
                    userApplicationType: userDetailsResponse?.applicationType ?? "",
                    userModeOfHolding: userDetailsResponse?.modeOfHolding ?? "",
                    application: userDetailsResponse?.application ?? {}
                })
            }
        }
    }

    const fetchCartData = async ({
        category,
        fundId,
        fetchCartItems = true,
        fetchUpdatedCartItemsOnDelete = false,
        fetchUpdatedCartItemsOnEdit = false,
        editCartItemPayload = {
            clientCode: "",
            cartId: "",
            amount: "",
            frequency: "",
            noOfInstallment: "",
            sipDate: "",
            endDate: "",
            mandateId: "",
            category: "",
            trType: "",
            folio: ""
        },
        isInitialApiCall = false
    }: {
        category?: string;
        fundId?: string[];
        fetchCartItems?: boolean;
        fetchUpdatedCartItemsOnDelete?: boolean;
        fetchUpdatedCartItemsOnEdit?: boolean;
        editCartItemPayload?: EditCartFormData;
        isInitialApiCall?: boolean
    }) => {
        if (role === USER_ROLES.INVESTOR && investorClientId) {
            let currentActiveCategory = category ? category : activeCategory

            setActiveCategory(currentActiveCategory)

            let cartItems = null;

            if (fetchCartItems) {
                cartItems = await (dispatch(getCartItems({
                    clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                    category: currentActiveCategory.toLowerCase(),
                    portfolioId: selectedPortfolio?.value
                })) as unknown as Promise<GetCartItemsResponseBody>)
            } else if (fetchUpdatedCartItemsOnDelete) {
                cartItems = await (dispatch(deleteCartItem({
                    clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                    cartIds: fundId ?? [],
                    category: currentActiveCategory.toLowerCase(),
                    portfolioId: selectedPortfolio?.value
                })) as unknown as Promise<DeleteCartItemResponseBody>)

                const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                    clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                    portfolioId: selectedPortfolio?.value
                })) as unknown as Promise<GetCartItemsCountResponseBody>)

                if (isSuccess) {
                    dispatch(setCartItemsCount(cartItemsCount));
                }
            } else if (fetchUpdatedCartItemsOnEdit) {
                const response = await (dispatch(editCartItem({
                    ...editCartItemPayload, portfolioId: selectedPortfolio?.value,
                })) as unknown as Promise<EditCartItemResponseBody>)

                if (response.isSuccess) {
                    cartItems = response.cartItems[0]
                    setEditDialogVisible(false)
                } else if (!response.isSuccess) {
                    setValidationErrorsArray([{ schemeName: "", errorMessage: response.message }])
                    setValidationDialogVisible(true)
                }
            }

            const nonZeroCategory = Object.entries(cartItems?.count ?? {
                newPurchase: 0,
                additionalPurchase: 0,
                swp: 0,
                stp: 0,
                redemption: 0,
                switch: 0
            }).find(([key, value]) => value !== 0)?.[0]

            if (isInitialApiCall && nonZeroCategory && nonZeroCategory !== "newPurchase") {
                cartItems = await (dispatch(getCartItems({
                    clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                    category: categoryMap[`${nonZeroCategory ?? ""}`].toLowerCase(),
                    portfolioId: selectedPortfolio?.value
                })) as unknown as Promise<GetCartItemsResponseBody>)

                setActiveCategory(categoryMap[`${nonZeroCategory ?? ""}`])

                currentActiveCategory = categoryMap[`${nonZeroCategory ?? ""}`]
            }

            if (cartItems && Object.keys(cartItems).length) {
                const recommendationsCartItems = cartItems?.recommendations ?? []
                const diyCartItems = cartItems?.diy ?? []
                const cartItemsCountObj = cartItems?.count ?? {
                    newPurchase: 0,
                    additionalPurchase: 0,
                    swp: 0,
                    stp: 0,
                    redemption: 0,
                    switch: 0
                }

                setCategoriesArray(prevState => prevState.map(obj => {
                    switch (obj.label) {
                        case "New Purchase":
                            return { ...obj, count: cartItemsCountObj?.newPurchase ?? 0 }
                        case "Additional Purchase":
                            return { ...obj, count: cartItemsCountObj?.additionalPurchase ?? 0 }
                        case "SWP":
                            return { ...obj, count: cartItemsCountObj?.swp ?? 0 }
                        case "STP":
                            return { ...obj, count: cartItemsCountObj?.stp ?? 0 }
                        case "Switch":
                            return { ...obj, count: cartItemsCountObj?.switch ?? 0 }
                        case "Redemption":
                            return { ...obj, count: cartItemsCountObj?.redemption ?? 0 }
                        default:
                            return obj
                    }
                }))

                setRecommendedFundsData(prevState => {
                    const prevCheckedMap: Record<string, boolean> = prevState.reduce(
                        (acc, obj) => ({ ...acc, [obj.id]: obj.checked }),
                        {}
                    )

                    return recommendationsCartItems.map(obj => {
                        const isLumpsum = ['fresh', 'additional'].includes(`${obj?.trType ?? ""}`.toLowerCase())
                        const isSip = obj?.trType?.toLowerCase() === "sip"
                        const isSwp = obj?.trType?.toLowerCase() === "swp"
                        const isStp = obj?.trType?.toLowerCase() === "stp"
                        const isSwitch = obj?.trType?.toLowerCase() === "switch"
                        const isRedemption = obj?.trType?.toLowerCase() === "redemption"

                        let cartItemDetails: CartItemDetails[] = []

                        if (isLumpsum) {
                            cartItemDetails = [
                                { label: "Transaction type", value: obj?.trType?.toLowerCase() ?? "-", isCapitalize: true },
                                { label: "Investment Value", value: toINR({ value: obj?.amount ?? "", locale, currencyCode }) }
                            ]
                        } else if (isSip) {
                            cartItemDetails = [
                                { label: "Transaction type", value: obj?.trType?.toUpperCase() ?? "-" },
                                { label: "Investment Value", value: toINR({ value: obj?.amount ?? "", locale, currencyCode }) },
                                { label: "Frequency", value: obj?.frequency?.toLowerCase() ?? "-", isCapitalize: true },
                                ...(obj?.sipUntilCancelFlag === "Y" ? [] : [{ label: "No. of Installments", value: obj?.noOfInstallment ?? "-" }]),
                                { label: "SIP Start Date", value: obj?.sipDate ?? "-" },
                                { label: "SIP EndDate", value: obj?.endDate ?? "-" },
                                { label: "Mandate", value: obj?.mandatesDisplayText ?? "-" }
                            ]
                        } else if (isSwp) {
                            cartItemDetails = [
                                { label: "SWP Amount", value: toINR({ value: obj?.amount ?? "", locale, currencyCode }) },
                                { label: "SWP Date", value: obj?.sipDate ?? "-" },
                                { label: "Frequency", value: obj?.frequency?.toLowerCase() ?? "-", isCapitalize: true },
                                { label: "No. of Installments", value: obj?.noOfInstallment ?? "-" },
                                { label: "Bank Name", value: obj?.bankName ? `${obj?.bankName}-${obj?.bankAccountNumber}` : "-" }
                            ]
                        } else if (isStp) {
                            cartItemDetails = [
                                { label: "Transfer Amount", value: toINR({ value: obj?.amount ?? "", locale, currencyCode }) },
                                { label: obj?.frequency?.toLowerCase() === "daily" ? "STP Start Date" : "STP Date", value: obj?.sipDate ?? "-" },
                                { label: "Frequency", value: obj?.frequency?.toLowerCase() ?? "-", isCapitalize: true },
                                ...(obj?.frequency?.toLowerCase() === 'daily' ? [{ label: "STP End Date", value: obj?.endDate ?? "-" }] : []),
                                ...(obj?.frequency?.toLowerCase() !== 'daily' ? [{ label: "No. of Installments", value: obj?.noOfInstallment ?? "-" }] : [])
                            ].filter(Boolean)
                        } else if (isSwitch) {
                            cartItemDetails = [
                                { label: obj?.amount ? "Switch Amount" : "Switch Units", value: obj?.amount ? toINR({ value: obj?.amount ?? "", locale, currencyCode }) : obj?.units ?? "" },
                            ]
                        } else if (isRedemption) {
                            cartItemDetails = [
                                { label: obj?.amount ? "Redeem Amount" : "Redeem Units", value: obj?.amount ? toINR({ value: obj?.amount ?? "", locale, currencyCode }) : obj?.units ?? "" },
                                { label: "Bank Details", value: obj?.bankName ? `${obj?.bankName}-${obj?.bankAccountNumber}` : "-" },
                            ]
                        }

                        return {
                            amcId: `${obj?.amcId}`,
                            id: `${obj.id}`,
                            fundType: "recommended",
                            transactionType: obj?.trType?.toLowerCase() ?? "",
                            amount: obj?.amount && !Number.isNaN(Number(obj.amount)) ? Number(obj.amount) : 0,
                            folioNumber: obj?.folioNo ?? null,
                            fromSchemeId: obj?.schemeId ?? "",
                            fromSchemeImg: obj?.schemeImg ?? "",
                            fromSchemeName: obj?.schemeName ?? "",
                            fromSchemeCategory: obj?.categoryName ?? "-",
                            fromSchemeSubCategory: obj?.subCategoryName ?? "-",
                            fromSchemeRisk: obj?.riskType ?? "",
                            fromSchemeRiskColor: colorMap[obj?.riskType ? obj.riskType.toLowerCase() : ""],
                            toSchemeId: obj?.toSchemeId ?? "",
                            toSchemeImg: obj?.toSchemeImg ?? "",
                            toSchemeName: obj?.toSchemeName ?? "",
                            toSchemeCategory: obj?.toCategoryName ?? "-",
                            toSchemeSubCategory: obj?.toSubCategoryName ?? "-",
                            toSchemeRisk: obj?.toRiskType ?? "",
                            toSchemeRiskColor: colorMap[obj?.toRiskType ? obj.toRiskType.toLowerCase() : ""],
                            balanceUnits: obj?.balanceUnits ?? "",
                            balanceAmount: obj?.balanceAmount ?? "",
                            bankAccountNumber: obj?.bankAccountNumber ?? "",
                            mandateId: obj?.mandateId ?? "",
                            mandatesDisplayText: obj?.mandatesDisplayText ?? "",
                            checked: prevCheckedMap[obj.id] ?? true,
                            transactionStartDate: obj?.sipDate ?? "",
                            endDate: obj?.endDate ?? "",
                            activeCategory: currentActiveCategory,
                            cartItemDetails,
                            recommedationId: obj?.recommedationId ?? null,
                            units: obj?.units ?? null,
                            noOfInstallments: Number(obj?.noOfInstallment) ?? null,
                            frequency: obj?.frequency ?? "",
                            allUnitsFlag: obj?.allUnitsFlag ? obj.allUnitsFlag : 'P',
                            transMode: obj?.transMode ?? '',
                            clientCode: obj?.clientCode ?? '',
                            schemeId: obj?.schemeId ?? "",
                            isDividendReinvestment: obj?.isDividendReinvestment ?? "",
                            firstOrder: obj?.firstOrderFlag === "Y" ? true : false,
                            sipUntilCancelFlag: obj?.sipUntilCancelFlag === "Y" ? true : false,
                            // ...(isStp ? {
                            //     endDate: obj?.endDate ?? '',
                            // } : {}),
                        }
                    })
                })

                setDiyFundsData(prevState => {
                    const prevCheckedMap: Record<string, boolean> = prevState.reduce(
                        (acc, obj) => ({ ...acc, [obj.id]: obj.checked }),
                        {}
                    )

                    return diyCartItems.map(obj => {
                        const isLumpsum = ['fresh', 'additional'].includes(`${obj?.trType ?? ""}`.toLowerCase())
                        const isSip = obj?.trType?.toLowerCase() === "sip"
                        const isSwp = obj?.trType?.toLowerCase() === "swp"
                        const isStp = obj?.trType?.toLowerCase() === "stp"
                        const isSwitch = obj?.trType?.toLowerCase() === "switch"
                        const isRedemption = obj?.trType?.toLowerCase() === "redemption"

                        let cartItemDetails: CartItemDetails[] = []

                        if (isLumpsum) {
                            cartItemDetails = [
                                { label: "Transaction type", value: obj?.trType?.toLowerCase() ?? "-", isCapitalize: true },
                                { label: "Investment Value", value: toINR({ value: obj?.amount ?? "", locale, currencyCode }) }
                            ]
                        } else if (isSip) {
                            cartItemDetails = [
                                { label: "Transaction type", value: obj?.trType?.toUpperCase() ?? "-" },
                                { label: "Investment Value", value: toINR({ value: obj?.amount ?? "", locale, currencyCode }) },
                                { label: "Frequency", value: obj?.frequency?.toLowerCase() ?? "-", isCapitalize: true },
                                ...(obj?.sipUntilCancelFlag === "Y" ? [] : [{ label: "No. of Installments", value: obj?.noOfInstallment ?? "-" }]),
                                { label: "SIP Date", value: obj?.sipDate ?? "-" },
                                { label: "SIP End Date", value: obj?.endDate ?? "-" },
                                { label: "Mandate", value: obj?.mandatesDisplayText ?? "-" }
                            ]
                        } else if (isSwp) {
                            cartItemDetails = [
                                { label: "SWP Amount", value: toINR({ value: obj?.amount ?? "", locale, currencyCode }) },
                                { label: "SWP Date", value: obj?.sipDate ?? "-" },
                                { label: "Frequency", value: obj?.frequency?.toLowerCase() ?? "-", isCapitalize: true },
                                { label: "No. of Installments", value: obj?.noOfInstallment ?? "-" },
                                { label: "Bank Name", value: obj?.bankName ? `${obj?.bankName}-${obj?.bankAccountNumber}` : "-" }
                            ]
                        } else if (isStp) {
                            cartItemDetails = [
                                { label: "Transfer Amount", value: toINR({ value: obj?.amount ?? "", locale, currencyCode }) },
                                { label: obj?.frequency?.toLowerCase() === 'daily' ? "STP Start Date" : "STP Date", value: obj?.sipDate ?? "-" },
                                { label: "Frequency", value: obj?.frequency?.toLowerCase() ?? "-", isCapitalize: true },
                                ...(obj?.frequency?.toLowerCase() === 'daily' ? [{ label: "STP End Date", value: obj?.endDate ?? "-" }] : []),
                                ...(obj?.frequency?.toLowerCase() !== 'daily' ? [{ label: "No. of Installments", value: obj?.noOfInstallment ?? "-" }] : [])
                            ]
                        } else if (isSwitch) {
                            cartItemDetails = [
                                { label: obj?.amount ? "Switch Amount" : "Switch Units", value: obj?.amount ? toINR({ value: obj?.amount ?? "", locale, currencyCode }) : obj?.units ?? "" }
                            ]
                        } else if (isRedemption) {
                            cartItemDetails = [
                                { label: obj?.amount ? "Redeem Amount" : "Redeem Units", value: obj?.amount ? toINR({ value: obj?.amount ?? "", locale, currencyCode }) : obj?.units ?? "" },
                                { label: "Bank Details", value: obj?.bankName ? `${obj?.bankName}-${obj?.bankAccountNumber}` : "-" },
                            ]
                        }

                        return {
                            amcId: `${obj?.amcId}`,
                            id: `${obj.id}`,
                            fundType: "diy",
                            transactionType: obj?.trType?.toLowerCase() ?? "",
                            folio: obj?.folioNo ?? "-",
                            navOnDate: obj?.navDate ?? "-",
                            nav: obj?.navValue ?? "-",
                            investedValue: obj?.investedValue ?? "",
                            marketValue: obj?.marketValue ?? "",
                            amount: obj?.amount && !Number.isNaN(Number(obj.amount)) ? Number(obj.amount) : 0,
                            folioNumber: obj?.folioNo ?? null,
                            fromSchemeId: obj?.schemeId ?? "",
                            fromSchemeImg: obj?.schemeImg ?? "",
                            fromSchemeName: obj?.schemeName ?? "",
                            fromSchemeCategory: obj?.categoryName ?? "-",
                            fromSchemeSubCategory: obj?.subCategoryName ?? "-",
                            fromSchemeRisk: obj?.riskType ?? "",
                            fromSchemeRiskColor: colorMap[obj?.riskType ? obj.riskType.toLowerCase() : ""],
                            toSchemeId: obj?.toSchemeId ?? "",
                            toSchemeImg: obj?.toSchemeImg ?? "",
                            toSchemeName: obj?.toSchemeName ?? "",
                            toSchemeCategory: obj?.toCategoryName ?? "-",
                            toSchemeSubCategory: obj?.toSubCategoryName ?? "-",
                            toSchemeRisk: obj?.toRiskType ?? "",
                            toSchemeRiskColor: colorMap[obj?.toRiskType ? obj.toRiskType.toLowerCase() : ""],
                            balanceUnits: obj?.balanceUnits ?? "",
                            balanceAmount: obj?.balanceAmount ?? "",
                            bankAccountNumber: obj?.bankAccountNumber ?? "",
                            mandateId: obj?.mandateId ?? "",
                            mandatesDisplayText: obj?.mandatesDisplayText ?? "",
                            transactionStartDate: obj?.sipDate ?? "",
                            checked: prevCheckedMap[obj.id] ?? true,
                            ...((isLumpsum || isSip) ? {
                                sipAmount: obj?.amount && !Number.isNaN(Number(obj.amount)) ? Number(obj.amount) : 0,
                                frequency: obj?.frequency ?? "",
                                noOfInstallments: obj?.noOfInstallment && !Number.isNaN(Number(obj.noOfInstallment)) ? Number(obj.noOfInstallment) : 0,
                                sipDate: obj?.sipDate ?? "",
                                endDate: obj?.endDate ?? "",
                                mandate: obj?.mandateId ?? "",
                                lumpsumAmount: obj?.amount && !Number.isNaN(Number(obj.amount)) ? Number(obj.amount) : 0,
                                mPowerScheme: obj?.mPowerScheme ?? "",
                                firstOrder: obj?.firstOrderFlag === "Y" ? true : false,
                                sipUntilCancelFlag: obj?.sipUntilCancelFlag === "Y" ? true : false
                            } : {}),
                            ...(isSwp ? {
                                swpAmount: obj?.amount && !Number.isNaN(Number(obj.amount)) ? Number(obj.amount) : 0,
                                frequency: obj?.frequency ?? "",
                                noOfInstallments: obj?.noOfInstallment && !Number.isNaN(Number(obj.noOfInstallment)) ? Number(obj.noOfInstallment) : 0,
                                swpDate: obj?.sipDate ?? "",
                                mandate: obj?.mandateId ?? "",
                                firstOrder: obj?.firstOrderFlag === "Y" ? true : false
                            } : {}),
                            ...(isStp ? {
                                stpAmount: obj?.amount && !Number.isNaN(Number(obj.amount)) ? Number(obj.amount) : 0,
                                frequency: obj?.frequency ?? "",
                                noOfInstallments: obj?.noOfInstallment && !Number.isNaN(Number(obj.noOfInstallment)) ? Number(obj.noOfInstallment) : 0,
                                stpDate: obj?.sipDate ?? "",
                                endDate: obj?.endDate ?? '',
                                firstOrder: obj?.firstOrderFlag === "Y" ? true : false
                            } : {}),
                            ...(isSwitch ? {
                                switchValue: obj?.amount && !Number.isNaN(Number(obj.amount)) ? Number(obj.amount) : Number(obj?.units ?? 0),
                                accountType: obj?.accountType ?? "",
                                transMode: obj?.transMode,
                            } : {}),
                            ...(isRedemption ? {
                                redeemValue: obj?.amount && !Number.isNaN(Number(obj.amount)) ? Number(obj.amount) : Number(obj?.units ?? 0),
                                mandate: obj?.mandateId ?? "",
                                transMode: obj?.transMode,
                            } : {}),
                            activeCategory: currentActiveCategory,
                            cartItemDetails,
                            recommedationId: obj?.recommedationId ?? null,
                            units: obj?.units ?? null,
                            allUnitsFlag: obj?.allUnitsFlag ? obj.allUnitsFlag : 'P',
                            transMode: obj?.transMode ?? '',
                            clientCode: obj?.clientCode ?? '',
                            freeUnits: Number(obj?.balanceUnits) ?? 0,
                            schemeId: obj?.schemeId ?? "",
                            isDividendReinvestment: obj?.isDividendReinvestment ?? ""
                        }
                    })
                })
            }
        }
    }

    const handleCategoryClick = async (currentCategory: string) => {
        try {
            setIsLoading(true)
            setRecommendedFundsData([])
            setDiyFundsData([])

            await fetchCartData({ category: currentCategory })
        } catch (error) {
            console.log("Error:", error)
        }
        finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true)
                await Promise.allSettled([fetchUserDetails(), fetchCartData({ isInitialApiCall: true })])
            } catch (error) {
                console.log("Error:", error)
            }
            finally {
                if (investorClientId) {
                    setIsLoading(false)
                }
            }
        }

        fetchData()
    }, [investorClientId])

    useEffect(() => {
        return () => cancelPlaceOrderOnSkip();
    }, []);

    const handleCheckboxClick = (currentFundType: string, currentFundId: string, checked: boolean) => {
        if (currentFundType === "recommended") {
            setRecommendedFundsData(prevState => prevState.map((item) => item.id === currentFundId ? { ...item, checked } : item))
        } else if (currentFundType === "diy") {
            setDiyFundsData(prevState => prevState.map((item) => item.id === currentFundId ? { ...item, checked } : item))
        }
    }

    const handleDeleteCartItem = async (currentFundId: string[]) => {
        try {
            setIsLoading(true)

            await fetchCartData({
                fundId: currentFundId,
                fetchCartItems: false,
                fetchUpdatedCartItemsOnDelete: true,
            })
        } catch (error) {
            console.log("Error:", error)
        }
        finally {
            setIsLoading(false)
        }
    }

    const handleOpenConfirmationDialog = async () => {
        if (isPortfolioHeldaway) {
            dispatch(showError(HELDAWAY_PORTFOLIO_STATUS))
            return
        }
        setConfirmationDialogVisible(true);
        // try {
        //     setEUINPopupLoading(true);
        //     const euinCheckRes = await dispatch(euinCheck({ rmId: `${iwappRmId}` })) as unknown as EnuinStatusObj;
        //     if (!euinCheckRes) return;
        //     setEUINPopupRes(euinCheckRes);
        //     if (euinCheckRes.isDefault) {
        //         setEUINPopupVisible(true);
        //         return;
        //     }
        //     setConfirmationDialogVisible(true);
        // } catch {
        //     console.error('Error while checking EUIN');
        // } finally {
        //     setEUINPopupLoading(false);
        // }
    }

    const handleEuinCheckClose = () => {
        setEUINPopupVisible(false);
        EUINPopupRes?.isValid && setConfirmationDialogVisible(true);
    }

    const handleCloseConfirmationDialog = () => {
        if (!isOrderPlaced) {
            setConfirmationDialogVisible(false)
        }
    }

    const handleDialogConfirmBtnClick = async () => {
        try {
            setOrderPlacedLoading(true)

            const selectedSchemes = [
                ...recommendedFundsData.filter(obj => obj.checked)
                    .map(obj => ({ ...obj, isRecommended: true, isDiy: false })),
                ...diyFundsData.filter(obj => obj.checked)
                    .map(obj => ({ ...obj, isRecommended: false, isDiy: true })),
            ]

            const payload = selectedSchemes.map(obj => {
                const isLumpsum = ['fresh', 'additional'].includes(`${obj?.transactionType ?? ""}`.toLowerCase())
                const isSip = obj.transactionType.toLowerCase() === "sip"
                const isSwitch = obj.transactionType.toLowerCase() === "switch"
                const isRedemption = obj.transactionType.toLowerCase() === "redemption"
                const isStp = obj.transactionType.toLowerCase() === "stp"
                const isSwp = obj.transactionType.toLowerCase() === "swp"

                let currentTransactionType = ""

                if (isLumpsum) {
                    if (obj.folioNumber && obj.folioNumber !== "New folio") currentTransactionType = "ADDITIONAL"
                    else currentTransactionType = "FRESH"
                }

                if (isSip) {
                    currentTransactionType = "XSIP"
                }
                if (isSwp) {
                    currentTransactionType = "SWP"
                }

                if (isSwitch) {
                    currentTransactionType = "SWITCH"
                }

                if (isRedemption) {
                    currentTransactionType = "REDEMPTION"
                }

                if (isStp) {
                    currentTransactionType = "STP"
                }

                return {
                    trType: currentTransactionType,
                    fromScheme: obj.fromSchemeId,
                    schemeName: obj.fromSchemeName,
                    fromSchemeName: obj.fromSchemeName,
                    toSchemeName: obj.toSchemeName ? obj.toSchemeName : "",
                    amount: obj.amount,
                    noOfInstallments: obj.noOfInstallments ? Number(obj.noOfInstallments) : 0,
                    mandateId: obj.mandateId ? obj.mandateId : "",
                    noOfWithdrawls: obj.noOfInstallments ? Number(obj.noOfInstallments) : 0,
                    frequency: obj.frequency ? obj.frequency : "",
                    units: obj.units ? obj.units : 0,
                    subBrokerArn: "",
                    bankAccountNumber: obj.bankAccountNumber ? obj.bankAccountNumber : "",
                    toScheme: obj.toSchemeId ? obj.toSchemeId : "",
                    noOfTransfers: obj.noOfInstallments ? Number(obj.noOfInstallments) : 0,
                    cartId: obj.id ? Number(obj.id) : null,
                    folio: obj.folioNumber ? obj.folioNumber !== "New folio" ? obj.folioNumber : "" : "",
                    subBrokerCode: "",
                    EUIN: "",
                    transactionStartDate: obj.transactionStartDate ? obj.transactionStartDate : "",
                    endDate: obj.endDate ? obj.endDate : "",
                    // transactionEndDate: obj.endDate ? obj.endDate : "",
                    transMode: obj.transMode ? obj.transMode : "",
                    redemptionType: currentTransactionType === "REDEMPTION" ? obj.allUnitsFlag === "N" ? "P" : "F" : null,
                    redemptionMode: currentTransactionType === "REDEMPTION" ? obj.transMode : null,
                    allUnitsFlag: obj.allUnitsFlag ? obj.allUnitsFlag : null,

                    amcId: obj.amcId ? obj.amcId : "",
                    clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                    isDiy: obj.isDiy,
                    isRecommended: obj.isRecommended,
                    rmId: `${iwappRmId}`,
                    recommendationId: obj.recommedationId ? obj.recommedationId : null,
                    mobile: userDetails.userMobile,
                    email: userDetails.userEmail,
                    portfolioId: selectedPortfolio?.value,
                    portfolioName: selectedPortfolio?.label,
                    ...(['XSIP', 'STP', 'SWP'].includes(`${currentTransactionType ?? ""}`.toUpperCase()) ? {
                        firstOrderFlag: obj?.firstOrder ? "Y" : "N",
                    } : {}),
                    ...(currentTransactionType === 'XSIP' ? {
                        sipUntilCancelFlag: obj?.sipUntilCancelFlag ? "Y" : "N",
                    } : {}),

                    ...(currentTransactionType === 'SWITCH' ? {
                        switchMode: obj.transMode ? obj.transMode : "",
                    } : {}),
                }
            })

            const response = await (dispatch(placeOrder({
                // ...(ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD ? {
                accountType: selectedPortfolioObj?.portfolioAccountType,
                // } : {}),
                orderDetails: payload
            })) as unknown as Promise<PlaceOrderResponseBody>)

            if (response.isSuccess) {
                // const notificationsPayload = {
                //     rmId: [USER_ROLES.RM].includes(role) ? [`${iwappRmId}`] : [],
                //     category: [],
                //     clientCode: [USER_ROLES.INVESTOR].includes(role) ? [clientInterfaceCode] : [],
                //     limit: 3,
                //     page: 1,
                //     sort: 'notificationTimestamp',
                //     order: 'DESC'
                // }
                // const getNotificationsData = (await dispatch(getNotifications(notificationsPayload))) as unknown as GetNotificationsResponseBody;
                // dispatch(storeNotifications(getNotificationsData.data ?? []));
                const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                    clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                    portfolioId: selectedPortfolio?.value
                })) as unknown as Promise<GetCartItemsCountResponseBody>)

                if (isSuccess) {
                    dispatch(setCartItemsCount(cartItemsCount));
                }

                if (!BSE_PAYMENT_FLOW) {
                    setOrderPlacedStatus(true)
                }
                else {
                    if (response?.otp_response?.isSuccess) {
                        history.push('/cart/verify-otp', {
                            token: response?.token ?? "",
                            cartId: response?.cartId ?? "",
                            otpResponseMessages: response?.otp_response?.otpResponseMessages ?? [],
                            // id: response?.otp_response?.id ?? "",
                            // otpMessage: response?.otp_response?.message ?? "",
                        })
                    } else if (!response?.otp_response?.isSuccess) {
                        setOtpErrorMessage(response?.otp_response?.message ?? "")
                        setOtpErrorDialogVisible(true)
                        setConfirmationDialogVisible(false)
                    }
                }
            } else if (!response.isSuccess) {
                setValidationErrorsArray(
                    response.ordersValidation
                        .filter(obj => !obj.isValid)
                        .map(obj => ({
                            schemeName: obj.schemeName,
                            errorMessage: obj.message
                        }))
                )
                setValidationDialogVisible(true)
                setConfirmationDialogVisible(false)
            }
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setOrderPlacedLoading(false)
            setConfirmationDialogVisible(false)
        }
    }

    const handleGoToOrdersClick = () => {
        dispatch(setAppliedFundsFilters([]));
        dispatch(setSelectedSchemesObj({}));

        if (role === USER_ROLES.INVESTOR) {
            history.push('/investor-dashboard')
        } else {
            history.push('/dashboard')
        }
        // history.push('investor-dashboard/mutual-fund/explore', { clientCode: investorClientId })
    }

    const handleEditCartItem = (data: CurrentEditObj) => {
        setCurrentEditObj({
            ...data,
            cartItemDetails: [{
                label: "Folio",
                value: data?.folio ?? "-"
            },
            {
                label: `NAV: -`,
                value: "-"
                // value: toINR({
                //     value: !Number.isNaN(Number(data?.nav ?? 0)) ?
                //         Math.round(Number(data?.nav ?? 0) * 100) / 100 : '0', locale, currencyCode
                // })
            },
            {
                label: "Invested Value",
                value: toINR({ value: data?.investedValue ?? "", locale, currencyCode })
            },
            {
                label: "Market Value",
                value: toINR({ value: data?.marketValue ?? "", locale, currencyCode })
            }
            ]
        })
        setEditDialogVisible(true)
    }

    const handleCloseEditDialog = () => {
        setCurrentEditObj({} as CurrentEditObj)
        setEditCartLoading(false)
        setEditDialogVisible(false)
    }

    const handleEditDialogSaveClick = async (id: string, currentTransactionType: string, currentEditCartFormData: Partial<EditCartFormData>) => {
        try {
            setEditCartLoading(true)

            const editCartItemPayload = {
                clientCode: investorClientId,
                cartId: Number(id),
                amount: "",
                frequency: "",
                noOfInstallment: "",
                sipDate: "",
                endDate: "",
                mandateId: "",
                category: activeCategory?.toUpperCase() ?? "",
                trType: currentTransactionType?.toUpperCase() ?? "",
                ...currentEditCartFormData
            }

            await fetchCartData({
                fetchCartItems: false,
                fetchUpdatedCartItemsOnEdit: true,
                editCartItemPayload
            })
        } catch (error) {
            console.log("Error:", error)
        }
        finally {
            setEditCartLoading(false)
        }
    }

    const handleEditDialogRemoveClick = async (currentFundId: string[]) => {
        try {
            setIsLoading(true)
            setEditDialogVisible(false)

            await fetchCartData({
                fundId: currentFundId,
                fetchCartItems: false,
                fetchUpdatedCartItemsOnDelete: true,
            })
        } catch (error) {
            console.log("Error:", error)
        }
        finally {
            setIsLoading(false)
        }
    }

    const handleValidationDialogClose = () => {
        setValidationDialogVisible(false)
    }

    const handleRiskProfileCheck = async () => {
        try {
            setRiskPflChkLoading(true)
            const riskProfileCheckRes = (await dispatch(getRiskProfileCheck({
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                schemeCode: schemeIds
            }))) as unknown as {
                isSuccess: boolean,
                displayText: string
            }
            if (!riskProfileCheckRes?.isSuccess) {
                setRiskProfilePopup(true)
                setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
            } else {
                handleOpenConfirmationDialog();
            }
        } catch (e) {
            console.log("Error: ", e)
        } finally {
            setRiskPflChkLoading(false)
        }

    }

    // const handleTransactionStatusCheck = async () => {
    //     try {
    //         setTransactionStatusChkLoading(true);
    //         const transactionStatusCheckRes = (await dispatch(getTransactionStatus({
    //             clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
    //         }))) as unknown as TransactionStatusObj;
    //         if (!transactionStatusCheckRes?.kycActive) {
    //             setTransactionStatusPopup(true)
    //             setTransactionStatusPopupRes(transactionStatusCheckRes)
    //         } else {
    //             handleOpenConfirmationDialog();
    //         }

    //     } catch (e) {
    //         console.log("Error: ", e)
    //     } finally {
    //         setTransactionStatusChkLoading(false)
    //     }
    // }

    const handleTransactionStatusCheck1 = async () => {
        try {
            setTransactionStatusChkLoading(true);
            registerPlaceOrderOnSkip(() => handleDialogConfirmBtnClick());
            const transactionStatusCheckRes = (await dispatch(getTransactionStatusCheck({
                rmId: `${iwappRmId ?? ''}`,
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                // transactionType: 'sip'
            }))) as unknown as getTransactionStatusCheckRes;
            if (!transactionStatusCheckRes) return;
            cancelPlaceOrderOnSkip();
            const showPopup = transactionStatusCheckRes.isMessage;
            if (showPopup) {
                setTransactionStatusCheckPopup(true);
                setTransactionStatusCheckPopupRes(transactionStatusCheckRes);
            } else {
                handleRiskProfileCheck()
            }
        } catch (e) {
            cancelPlaceOrderOnSkip();
            console.log("Error: ", e)
        } finally {
            setTransactionStatusChkLoading(false)
        }
    }

    const handleTransactionStatusPopup = (btnText: string) => {
        setTransactionStatusPopup(false);
        if (btnText === 'continue') {
            handleOpenConfirmationDialog();
        }
    }

    const handleTransactionStatusCheckPopup = (btnText: string) => {
        setTransactionStatusCheckPopup(false);
        if (btnText === 'continue') {
            // handleOpenConfirmationDialog();
            handleRiskProfileCheck();
        }
    }

    const handleRiskProfilePopup = (btnText: string) => {
        setRiskProfilePopup(false);
        if (btnText === 'continue') {
            handleOpenConfirmationDialog();
        }
    }

    const handleOtpErrorDialogClose = () => {
        setOtpErrorDialogVisible(false)
    };

    const handleEdit = async () => {
        const state = {
            clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
            selectedSchemes: diyFundsData.map((item: any) => ({
                scheme: item.schemeId,
                divReinvestAllowed: item.isDividendReinvestment,
                uniqueId: `${window.crypto.randomUUID()}-${item?.isinCode ?? ""}-${item?.folioNumber ?? ""}`,
                id: item.id,
                folioId: item.folioNumber,
                marketValue: item.marketValue,
                investedValue: item.investedValue,
                isReinvestment: item?.isReinvest,
                isinCode: item?.isinCode
            })),
            schemeDetails: diyFundsData.map((item: any) => ({
                isReinvestment: item?.isReinvest,
                scheme_id: item?.schemeId
            })),
            fund: diyFundsData.map((item: any) => {
                return {
                    sip: {
                        sipamount: item.sipAmount ?? "",
                        periods: item?.frequency ?? "",
                        installments: item?.noOfInstallments ?? "",
                        sipDate: formatDateToIST(item.sipDate) ?? "",
                        endDate: formatDateToIST(item.endDate) ?? "",
                        // mandate: item?.mandate ?? "",
                        mandate: item?.mandateId ?? '',
                        sipFolio: item?.folioNumber ?? "",
                        firstOrder: item?.firstOrder,
                        // firstOrder: `${item?.firstOrderFlag ?? ''}`.toLowerCase() == 'y' ? true : false,
                        folioId: item?.folioNumber,
                        sipUntilCancelFlag: item?.sipUntilCancelFlag
                    },
                    lumpsum: {
                        lumpAmount: item?.lumpsumAmount,
                        lumpsumFolio: item?.folioNumber,
                    },
                    activeTab: ['fresh', 'additional'].includes(`${item?.transactionType ?? ''}`.toLowerCase()) ? 'Lumpsum' : 'SIP',
                    schemeId: item.schemeId,
                    uniqueId: `${window.crypto.randomUUID()}-${item?.isinCode ?? ""}-${item?.folioNumber ?? ""}`,
                }
            }),
            folio: diyFundsData.map((item: any) => ({
                folioId: item?.folioNumber,
                investedValue: item?.investedValue,
                marketValue: item?.marketValue,
                schemeId: item?.schemeId,
                id: item?.mPowerScheme
            })),
        }

        const cartIds = state?.selectedSchemes?.map((item: any) => item?.id);

        if (activeCategory === categoryMap['newPurchase']) {
            const res = await (dispatch(deleteCartItem({
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                cartIds: cartIds,
                category: `${activeCategory ?? ''}`.toLowerCase(),
                portfolioId: selectedPortfolio?.value
            })) as unknown as Promise<DeleteCartItemResponseBody>)
            if (!res) {
                return;
            }
            const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                portfolioId: selectedPortfolio?.value
            })) as unknown as Promise<GetCartItemsCountResponseBody>)

            if (isSuccess) {
                dispatch(setCartItemsCount(cartItemsCount));
            }

            history.push('/investor-dashboard/mutual-fund/explore/selected-category-funds/investment-details', state);
            return;
        }
        if (activeCategory === categoryMap['additionalPurchase']) {
            const res = await (dispatch(deleteCartItem({
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                cartIds: cartIds,
                category: `${activeCategory ?? ''}`.toLowerCase(),
                portfolioId: selectedPortfolio?.value
            })) as unknown as Promise<DeleteCartItemResponseBody>);

            if (!res) {
                return;
            }
            const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                portfolioId: selectedPortfolio?.value
            })) as unknown as Promise<GetCartItemsCountResponseBody>)

            if (isSuccess) {
                dispatch(setCartItemsCount(cartItemsCount));
            }
            history.push('/investor-dashboard/mutual-fund/invest-more', state);
            // history.push('/investor-dashboard/mutual-fund/explore/selected-category-funds/investment-details', state);
            return;
        }
    }

    const totalAmount = recommendedFundsData.reduce((acc, curr) => curr.checked ? acc + curr.amount : acc, 0) + diyFundsData.reduce((acc, curr) => curr.checked ? acc + curr.amount : acc, 0)
    const totalUnits = recommendedFundsData.reduce((acc, curr) => curr.checked ? acc + Number(curr.units) : acc, 0) + diyFundsData.reduce((acc, curr) => curr.checked ? acc + Number(curr.units) : acc, 0)

    const isMinor = isOnboardingTypeMinor(userDetails?.application?.onboardingType || '');
    const investorName = isMinor ? `${userDetails?.application?.applicants?.[0]?.minorFirstName} ${userDetails?.application?.applicants?.[0]?.minorLastName}` : userDetails?.userName;

    return (
        <>
            {isLoading && (
                <LoadingComponent
                    showToScheme={
                        activeCategory.toLowerCase() === 'stp' ||
                        activeCategory.toLowerCase() === 'switch'
                    }
                />
            )}
            {!isLoading && (
                <Box>
                    <Typography
                        variant="h1"
                        sx={(theme: Theme) => ({
                            lineHeight: "32.5px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Cart
                    </Typography>
                    <Box
                        sx={(theme: Theme) => ({
                            marginTop: "25px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${theme.palette.customColors.pastelGrey}`,
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            gap: '20px',
                            overflowX: 'auto',
                            whiteSpace: 'nowrap',
                            scrollbarWidth: 'none', // Hide scrollbar in Firefox
                            '&::-webkit-scrollbar': {
                                display: 'none', // Hide scrollbar in WebKit browsers
                            },
                        })}
                    >
                        {categoriesArray.map((
                            { label, count }: { label: string; count: number }
                        ) => (
                            <Button
                                key={label}
                                sx={(theme: Theme) => ({
                                    display: 'inline-block',
                                    minWidth: "fit-content",
                                    padding: '3px 10px',
                                    backgroundColor: activeCategory === label ?
                                        theme.palette.primary[500] :
                                        theme.palette.background.default,
                                    color: activeCategory === label ?
                                        theme.palette.textDark.primary :
                                        theme.palette.text.secondary,
                                    borderRadius: '7px',
                                    "&:hover": {
                                        backgroundColor: activeCategory === label ?
                                            theme.palette.primary[200] :
                                            'transparent',
                                        boxShadow: "none"
                                    },
                                })}
                                onClick={() => handleCategoryClick(label)}
                            >
                                <Typography
                                    component="span"
                                    variant="body_500"
                                    sx={{
                                        letterSpacing: '0.02px',
                                        marginRight: '0.3rem',
                                        lineHeight: '20px'
                                    }}
                                >
                                    {label}
                                </Typography>
                                <Typography
                                    component="span"
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        padding: '0px 10px',
                                        backgroundColor: activeCategory === label ?
                                            theme.palette.textDark.primary :
                                            theme.palette.primary[50],
                                        color: theme.palette.primary[500],
                                        borderRadius: '7px',
                                        letterSpacing: '0.02px',
                                        margin: "3px 0px",
                                        lineHeight: '20px'
                                    })}
                                >
                                    {count}
                                </Typography>
                            </Button>
                        ))}
                    </Box>
                    <Grid
                        container
                        sx={{ marginTop: "25px" }}
                        spacing={3}
                    >
                        <Grid
                            item
                            xs={12}
                            lg={8}
                        >
                            <Box
                                sx={(theme: Theme) => ({
                                    borderRadius: "20px",
                                    backgroundColor: theme.palette.common.white,
                                    padding: "25px 30px 35px 20px",
                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                                })}
                            >
                                <Typography
                                    variant="h2"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        lineHeight: "25px",
                                        letterSpacing: "0.01px"
                                    })}
                                >
                                    Suggested Funds
                                </Typography>
                                {recommendedFundsData.length > 0 && (
                                    <Box
                                        sx={{
                                            marginTop: "35px",
                                            display: "flex",
                                            flexDirection: "column",
                                            rowGap: "35px"
                                        }}
                                    >
                                        {recommendedFundsData.map((obj, index) => {
                                            const { amount, ...modifiedObj } = obj

                                            return (
                                                <Fragment key={obj.id}>
                                                    <CartItemInfo
                                                        onCheckboxClick={handleCheckboxClick}
                                                        onDeleteClick={handleDeleteCartItem}
                                                        isEditEnabled={false}
                                                        {...modifiedObj}
                                                    />
                                                    {recommendedFundsData.length - 1 !== index && (
                                                        <Box sx={(theme: Theme) => ({ border: `0.1px solid ${theme.palette.text.secondary}B3` })} />
                                                    )}
                                                </Fragment>
                                            )
                                        })}
                                    </Box>
                                )}
                                {recommendedFundsData.length === 0 && (
                                    <Box
                                        sx={{
                                            marginTop: "35px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Typography
                                            variant="body_600"
                                            sx={(theme: Theme) => ({
                                                color: theme.palette.text.primary
                                            })}
                                        >
                                            No Suggested Funds Found
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                            <Box
                                sx={(theme: Theme) => ({
                                    marginTop: "25px",
                                    borderRadius: "20px",
                                    backgroundColor: theme.palette.common.white,
                                    padding: "35px 30px 35px 20px",
                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                                })}
                            >
                                <Typography
                                    variant="h2"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        lineHeight: "25px",
                                        letterSpacing: "0.01px"
                                    })}
                                >
                                    DIY Funds
                                </Typography>
                                {diyFundsData.length > 0 && (
                                    <Box
                                        sx={{
                                            marginTop: "35px",
                                            display: "flex",
                                            flexDirection: "column",
                                            rowGap: "35px"
                                        }}
                                    >
                                        {diyFundsData.map((obj, index) => {
                                            const { amount, ...modifiedObj } = obj
                                            return (
                                                <Fragment key={obj.id}>
                                                    <CartItemInfo
                                                        onCheckboxClick={handleCheckboxClick}
                                                        onDeleteClick={handleDeleteCartItem}
                                                        onEditClick={COMMON_EDIT ? isNewAdditionalPurchase(activeCategory) ? handleEdit : handleEditCartItem : handleEditCartItem}
                                                        isEditEnabled={true}
                                                        {...modifiedObj}
                                                    />
                                                    {diyFundsData.length - 1 !== index && (
                                                        <Box sx={(theme: Theme) => ({ border: `0.1px solid ${theme.palette.text.secondary}B3` })} />
                                                    )}
                                                </Fragment>
                                            )
                                        })}
                                    </Box>
                                )}
                                {diyFundsData.length === 0 && (
                                    <Box
                                        sx={{
                                            marginTop: "35px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Typography
                                            variant="body_600"
                                            sx={(theme: Theme) => ({
                                                color: theme.palette.text.primary
                                            })}
                                        >
                                            No DIY Funds Found
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={4}
                        >
                            <Box
                                sx={(theme: Theme) => ({
                                    borderRadius: "20px",
                                    padding: "25px 30px 30px 30px",
                                    backgroundColor: theme.palette.common.white,
                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                                })}
                            >
                                <Box
                                    sx={(theme: Theme) => ({
                                        display: "flex",
                                        flexDirection: "column",
                                        columnGap: "15px",
                                        // alignItems: "center",
                                        paddingBottom: "35px",
                                        borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`
                                    })}>

                                    <Box sx={{
                                        display: "flex",
                                        columnGap: "15px",
                                        alignItems: "center",
                                        paddingBottom: "35px",
                                    }}>
                                        <Avatar
                                            sx={(theme: Theme) => ({
                                                ...theme.typography.h3,
                                                fontSize: "24px",
                                                width: "58px",
                                                height: "58px",
                                                lineHeight: "30px",
                                                letterSpacing: "0.02px",
                                                color: theme.palette.primary[500],
                                                backgroundColor: theme.palette.primary[50]
                                            })}
                                        >
                                            {getAbbreviatedName(investorName)}
                                        </Avatar>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                rowGap: "5px",
                                            }}
                                        >
                                            <Typography
                                                variant="h2"
                                                sx={(theme: Theme) => ({
                                                    lineHeight: "25px",
                                                    letterSpacing: "0.01px",
                                                    color: theme.palette.text.primary
                                                })}
                                            >
                                                {maskInfo(investorName)}
                                            </Typography>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "5px",
                                                    flexWrap: "wrap"
                                                }}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: theme.palette.text.secondary,
                                                        textTransform: "capitalize"
                                                    })}
                                                >
                                                    {userDetails.userApplicationType}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        width: "3px",
                                                        height: "3px",
                                                        backgroundColor: "text.secondary",
                                                        alignSelf: "center",
                                                        borderRadius: "50%"
                                                    }}
                                                />
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    {selectedPortfolio?.label ?? ""}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        width: "3px",
                                                        height: "3px",
                                                        backgroundColor: "text.secondary",
                                                        alignSelf: "center",
                                                        borderRadius: "50%"
                                                    }}
                                                />
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    {userDetails.userAccountType}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        width: "3px",
                                                        height: "3px",
                                                        backgroundColor: "text.secondary",
                                                        alignSelf: "center",
                                                        borderRadius: "50%"
                                                    }}
                                                />
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: theme.palette.text.secondary,
                                                        textTransform: "capitalize"
                                                    })}
                                                >
                                                    {userDetails.userModeOfHolding}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        width: "3px",
                                                        height: "3px",
                                                        backgroundColor: "text.secondary",
                                                        alignSelf: "center",
                                                        borderRadius: "50%"
                                                    }}
                                                />
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    {
                                                        isMinor
                                                            ? "Minor"
                                                            : userDetails?.userStatus ?
                                                                applicantStatusMasters[userDetails.userStatus] ?
                                                                    applicantStatusMasters[userDetails.userStatus] : userDetails.userStatus
                                                                : "N/A"
                                                    }
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                    {/* Disclaimer */}
                                    <Box sx={{ width: '100%', mt: 3 }}>
                                        <FormGroup>
                                            <FormControlLabel
                                                sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}
                                                control={
                                                    <Checkbox
                                                        size="medium"
                                                        disableRipple
                                                        checkedIcon={<CheckIcon />}
                                                        icon={<UnCheckIcon />}
                                                        sx={{
                                                            padding: 0,
                                                            '&:hover': {
                                                                backgroundColor: 'transparent',
                                                            },
                                                        }}

                                                        onChange={() => setIsTxnDialog(true)}
                                                        checked={disclaimerChecked}
                                                    />}
                                                label={<TransactionsDisclaimer disclaimerChecked={disclaimerChecked} setDisclaimerChecked={setDisclaimerChecked} />}
                                            />

                                        </FormGroup>
                                    </Box>
                                </Box>
                                <Hidden lgUp>
                                    <Box
                                        sx={{
                                            marginTop: "35px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            columnGap: "10px"
                                        }}
                                    >
                                        <Typography
                                            variant="subtitle_500"
                                            sx={(theme: Theme) => ({
                                                lineHeight: "14px",
                                                color: theme.palette.text.secondary
                                            })}
                                        >
                                            Total {(activeCategory === 'Switch' || activeCategory === 'Redemption') ? 'Amount / Units' : 'Amount'}
                                        </Typography>
                                        <Typography
                                            variant="h2"
                                            sx={(theme: Theme) => ({
                                                lineHeight: "25px",
                                                color: theme.palette.text.primary
                                            })}
                                        >
                                            {toINR({ value: totalAmount, locale, currencyCode })} {(activeCategory === 'Switch' || activeCategory === 'Redemption') ? `/ ${totalUnits?.toFixed(2)}` : ''}
                                        </Typography>
                                    </Box>
                                </Hidden>
                                <Hidden lgDown >
                                    <Box
                                        sx={{
                                            marginTop: "35px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            rowGap: "10px"
                                        }}
                                    >
                                        <Typography
                                            variant="h3"
                                            sx={(theme: Theme) => ({
                                                fontSize: "32px",
                                                lineHeight: "40px",
                                                color: theme.palette.text.primary
                                            })}
                                        >
                                            {toINR({ value: totalAmount, locale, currencyCode })} {(activeCategory === 'Switch' || activeCategory === 'Redemption') ? `/ ${totalUnits.toFixed(2)}` : ''}
                                        </Typography>
                                        <Typography
                                            variant="body_500"
                                            sx={(theme: Theme) => ({
                                                lineHeight: "16px",
                                                color: theme.palette.text.secondary
                                            })}
                                        >
                                            Total {(activeCategory === 'Switch' || activeCategory === 'Redemption') ? 'Amount / Units' : 'Amount'}
                                        </Typography>
                                    </Box>
                                </Hidden>
                                <Grid
                                    container
                                    item
                                    xs={12}
                                    spacing={2}
                                    sx={{ marginTop: "35px" }}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                    >
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            sx={(theme: Theme) => ({
                                                // marginTop: "35px",
                                                padding: "15px",
                                                borderRadius: "10px",
                                                backgroundColor: theme.palette.primary[500],
                                                color: theme.palette.textDark.primary,
                                                lineHeight: "22.5px",
                                                letterSpacing: "0.02px"
                                            })}
                                            disabled={(totalAmount === 0 && totalUnits === 0) || TransactionStatusChkLoading || EUINPopupLoading || !disclaimerChecked}
                                            onClick={handleTransactionStatusCheck1}
                                        >
                                            Confirm
                                        </Button>
                                    </Grid>
                                </Grid>

                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            )}
            <Dialog
                // onClose={handleCloseConfirmationDialog}
                open={isConfirmationDialogVisible}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                {!isOrderPlaced && (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "48px"
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                rowGap: "12px"
                            }}
                        >
                            <Typography
                                variant="h2"
                                sx={(theme: Theme) => ({
                                    lineHeight: "25px",
                                    letterSpacing: "0.01px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                Confirm!
                            </Typography>
                            <Typography
                                variant="subtitle_400"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.secondary
                                })}
                            >
                                Are you sure you want to continue with this action?
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: "12px"
                            }}
                        >
                            <Box sx={{ flex: "1 1 50%" }}>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    sx={(theme: Theme) => ({
                                        borderRadius: "4px",
                                        border: `1px solid ${theme.palette.customColors.pastelGrey}`,
                                        padding: "13px 56px",
                                        ...theme.typography.body_600,
                                        fontSize: "16px",
                                        lineHeight: "20px",
                                        color: theme.palette.text.primary,
                                        ":hover": {
                                            backgroundColor: theme.palette.grey[50],
                                            borderColor: theme.palette.grey[400]
                                        }
                                    })}
                                    onClick={handleCloseConfirmationDialog}
                                    disabled={isOrderPlacedLoading}
                                >
                                    Cancel
                                </Button>
                            </Box>
                            <Box sx={{ flex: "1 1 50%" }}>
                                <LoadingButton
                                    loading={isOrderPlacedLoading}
                                    variant="contained"
                                    fullWidth
                                    sx={(theme: Theme) => ({
                                        borderRadius: "4px",
                                        padding: "14px 20px",
                                        backgroundColor: theme.palette.primary[500],
                                        boxShadow: "none",
                                        ...theme.typography.body_600,
                                        fontSize: "16px",
                                        lineHeight: "20px",
                                        color: theme.palette.common.white
                                    })}
                                    onClick={handleDialogConfirmBtnClick}
                                >
                                    Confirm
                                </LoadingButton>
                            </Box>
                        </Box>
                    </Box>
                )}
                {isOrderPlaced && (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "48px"
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "15px",
                                rowGap: "12px"
                            }}
                        >
                            <SuccessIcon />
                            <Typography
                                variant="h2"
                                sx={(theme: Theme) => ({
                                    lineHeight: "25px",
                                    letterSpacing: "0.01px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                Success!
                            </Typography>
                            <Typography
                                variant="subtitle_400"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.secondary,
                                    textAlign: "center"
                                })}
                            >
                                The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction.
                            </Typography>
                        </Box>
                        <Box>
                            <Button
                                variant="contained"
                                fullWidth
                                sx={(theme: Theme) => ({
                                    borderRadius: "4px",
                                    padding: "13px 20px",
                                    backgroundColor: theme.palette.primary[500],
                                    ...theme.typography.body_600,
                                    fontSize: "16px",
                                    lineHeight: "20px"
                                })}
                                onClick={handleGoToOrdersClick}
                            >
                                Go to Dashboard
                            </Button>
                        </Box>
                    </Box>
                )}
            </Dialog>
            <Dialog
                onClose={handleCloseEditDialog}
                open={isEditDialogVisible}
                maxWidth='lg'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '25px',
                        backgroundColor: theme.palette.common.white,
                        padding: "35px",
                        width: "1063px",
                    },
                })}
            >
                <EditCartItem
                    onCancel={handleCloseEditDialog}
                    onSave={handleEditDialogSaveClick}
                    onRemove={handleEditDialogRemoveClick}
                    isLoading={isEditCartLoading}
                    {...currentEditObj}
                />
            </Dialog>
            <Dialog
                onClose={handleValidationDialogClose}
                open={isValidationDialogVisible}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        rowGap: "30px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            rowGap: "14px",
                            paddingTop: "15px"
                        }}
                    >
                        <Box
                            component="img"
                            src="/images/error.svg"
                            alt="Error"
                            sx={{ objectFit: "contain" }}
                        />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Failed!
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            maxHeight: "350px",
                            overflowY: "auto",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: validationErrorsArray.length === 1 ? "center" : "flex-start",
                            alignItems: "center",
                            rowGap: "10px"
                        }}
                    >
                        {validationErrorsArray.map((obj: { schemeName: string; errorMessage: string }, index: number) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    rowGap: "10px"
                                }}
                            >
                                {obj.schemeName && (
                                    <Typography
                                        variant="subtitle_400"
                                        sx={(theme: Theme) => ({
                                            fontWeight: "600",
                                            lineHeight: "20px",
                                            letterSpacing: "0.02px",
                                            color: theme.palette.text.secondary
                                        })}
                                    >
                                        {obj.schemeName}
                                    </Typography>
                                )}
                                <Typography
                                    variant="subtitle_400"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.secondary,
                                        paddingBottom: "10px"
                                    })}
                                >
                                    {obj.errorMessage.charAt(0).toUpperCase() + obj.errorMessage.slice(1)}
                                </Typography>
                                {validationErrorsArray.length - 1 !== index && (
                                    <Box
                                        sx={(theme: Theme) => ({
                                            width: "30%",
                                            border: `0.5px dashed ${theme.palette.text.secondary}`
                                        })}
                                    />
                                )}
                            </Box>
                        ))}
                    </Box>
                    <Button
                        variant="contained"
                        fullWidth
                        sx={(theme: Theme) => ({
                            padding: "13px 20px",
                            borderRadius: "4px",
                            backgroundColor: theme.palette.primary[500],
                            fontWeight: 600,
                            fontSize: "16px",
                            lineHeight: "20px"
                        })}
                        onClick={handleValidationDialogClose}
                    >
                        Okay
                    </Button>
                </Box>
            </Dialog >
            <Dialog
                onClose={handleOtpErrorDialogClose}
                open={isOtpErrorDialogVisible}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        rowGap: "30px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            rowGap: "14px",
                            paddingTop: "15px"
                        }}
                    >
                        <Box
                            component="img"
                            src="/images/error.svg"
                            alt="Error"
                            sx={{ objectFit: "contain" }}
                        />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Failed!
                        </Typography>
                    </Box>
                    <Typography
                        variant="subtitle_400"
                        sx={(theme: Theme) => ({
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        })}
                    >
                        {otpErrorMessage ?? ""}
                    </Typography>
                    <Button
                        variant="contained"
                        fullWidth
                        sx={(theme: Theme) => ({
                            padding: "13px 20px",
                            borderRadius: "4px",
                            backgroundColor: theme.palette.primary[500],
                            fontWeight: 600,
                            fontSize: "16px",
                            lineHeight: "20px"
                        })}
                        onClick={handleOtpErrorDialogClose}
                    >
                        Okay
                    </Button>
                </Box>
            </Dialog >

            <EUINPopup open={EUINPopupVisible} setClose={() => setEUINPopupVisible(false)} handleEuinCheckClose={handleEuinCheckClose} euinRes={EUINPopupRes} />
            <RiskProfilePopup open={riskProfilePopup} setClose={handleRiskProfilePopup} text={riskPopupText} />
            <TransactionStatusPopup open={transactionStatusPopup} setClose={handleTransactionStatusPopup} res={transactionStatusPopupRes} />
            <TransactionStatusCheckPopup open={transactionStatusCheckPopup} setClose={handleTransactionStatusCheckPopup} res={transactionStatusCheckPopupRes} />
            <TransactionsDisclaimerText
                handleDialogClose={() => {
                    setIsTxnDialog(false);
                    setDisclaimerChecked(true);
                }}
                isDialog={isTxnDialog}
            />
        </>
    )
}